import DealerText from './DealerText';

export default DealerText;
